import { listBonusAssignments } from './queries/listBonusAssignments';
import { listBonusComponents } from './queries/listBonusComponents';
import { createBonusAssignment } from './mutations/createBonusAssignment';
import { updateBonusAssignment } from './mutations/updateBonusAssignment';
import { cancelBonusAssignment } from './mutations/cancelBonusAssignment';

const queries = {
  listBonusAssignments,
  listBonusComponents,
};

const mutations = {
  createBonusAssignment,
  updateBonusAssignment,
  cancelBonusAssignment,
};

const bonusAssignmentGql = {
  queries,
  mutations,
};

export default bonusAssignmentGql;
